import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// COMPONENTS
import { CoreIcons } from 'components';
import { Typography } from '@telavita-core/react-design-kit'

const ProfessionalChip = ({ name, photo, professionalRole = '', customClassName }) => {
  return (
    <div className={clsx({
      'ProfessionalChip': true,
      [customClassName]: !!customClassName
    })}>
      <div className="ProfessionalChip__info">
        <Typography variant='content2'>
          Marcar com {professionalRole}
        </Typography>
        <Typography variant='content2' weight='bolder'>
          {name}
        </Typography>
      </div>
      {
        photo ? 
          <div
            className="ProfessionalChip__image"
            style={{ backgroundImage: `url('${photo}')` }}
          ></div>
        :
          <CoreIcons
            name="UserAvatar"
            height="40px"
            width="40px"
            fill="#4B4B4B"
          />
      }
      
  
    </div>
  );
};

ProfessionalChip.propTypes = {
  name: PropTypes.string,
  photo: PropTypes.string
};

export default ProfessionalChip;